var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white",
    strokeOpacity: 0.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 17H19C17.897 17 17 17.897 17 19V31C17 32.103 17.897 33 19 33H25V27.5H23V25H25V23C25 22.2044 25.3161 21.4413 25.8787 20.8787C26.4413 20.3161 27.2044 20 28 20H30V22.5H29C28.448 22.5 28 22.448 28 23V25H30.5L29.5 27.5H28V33H31C32.103 33 33 32.103 33 31V19C33 17.897 32.103 17 31 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.ea58e463b6980f26813ccf6c56655228.svg";
export { ForwardRef as ReactComponent };